import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, signal, Type } from '@angular/core';
import { ToggleBlock } from '../../../model';

@Component({
  selector: 'dojo-toggle-block-renderer',
  templateUrl: './toggle-block-renderer.component.html',
  styleUrls: ['./toggle-block-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet],
})
export class ToggleBlockRendererComponent {
  readonly block = input.required<ToggleBlock>();
  readonly contentRenderer = input.required<Type<unknown>>();

  readonly expanded = signal(false);

  toggleExpanded(): void {
    this.expanded.update((v) => !v);
  }
}
